import { faCoffee } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styled from "styled-components";
import { BaseBox, Title } from "../shared";

const Container = styled(BaseBox)`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 35px 40px 25px 40px;
  margin-bottom: 10px;
  form {
    margin-top: 35px;
    width: 100%;
    display: flex;
    justify-items: center;
    flex-direction: column;
    align-items: center;
  }
`;

const FormBox: React.FC = ({ children }) => {
  return (
    <Container>
      <Title>Nomad Coffee</Title>
      <FontAwesomeIcon icon={faCoffee} size="3x" />
      {children}
    </Container>
  );
};
export default FormBox;
